import { z } from 'zod'

// Create dynamic schema based on user role
export const createPrescriptionSchema = (requiresCompanySelection: boolean) => z.object({
    NomePaziente: z.string().min(1, 'Nome paziente obbligatorio'),
    medico_id: z.string().min(1, 'Seleziona un medico'),
    prestazione_id: z.string().min(1, 'Seleziona una prestazione'),
    company_id: requiresCompanySelection
        ? z.string().min(1, 'Seleziona una clinica')
        : z.string().optional(),
    selectedTeeth: z.array(z.string()),
    selectedImplants: z.array(z.string()).default([]),
    tipo_prova: z.string().min(1, 'Seleziona una fase di lavoro'),
    prova_id: z.number().min(1, 'Fase di lavoro obbligatoria'),
    tinta: z.string().min(1, 'Seleziona una tinta'),
    color_id: z.number().min(0, 'Tinta obbligatoria'),
    dataapp: z.string().min(1, 'Seleziona una data'),
    timeapp: z.string().min(1, 'Seleziona un orario'),
    scansione_intraorale: z.boolean().default(false),
    chiama_medico: z.boolean().default(false),
    presa_fisica_corriere: z.boolean().default(false),
    note: z.string().optional(),
}).superRefine((data, ctx) => {
    if (data.selectedTeeth.length === 0) {
        ctx.addIssue({
            code: 'custom',
            path: ['selectedTeeth'],
            message: data.selectedImplants.length > 0
                ? 'Hai selezionato solo impianti. Seleziona almeno un dente per continuare.'
                : 'Manca almeno un dente. Selezionalo sull\u2019odontogramma per continuare.',
        })
    }
    if (data.scansione_intraorale === data.presa_fisica_corriere) {
        ctx.addIssue({
            code: 'custom',
            path: ['scansione_intraorale'],
            message: 'Scegli una sola modalità: digitale oppure analogica',
        })
    }
})

export type PrescriptionFormInput = z.input<ReturnType<typeof createPrescriptionSchema>>
export type PrescriptionFormData = z.output<ReturnType<typeof createPrescriptionSchema>>

